import { useEffect } from 'react';
import { Form, Input, Button, Space, Switch } from 'antd';
import type { TipoServicioResponse } from '@aid/shared';

interface TipoServicioFormProps {
  mode: 'create' | 'edit';
  initialValues?: TipoServicioResponse | null;
  onSubmit: (values: Record<string, unknown>) => void;
  loading?: boolean;
}

export function TipoServicioForm({
  mode,
  initialValues,
  onSubmit,
  loading,
}: TipoServicioFormProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        nombre: initialValues.nombre ?? '',
        generaCobro: initialValues.generaCobro,
      });
    }
  }, [initialValues, form]);

  const handleFinish = (values: Record<string, unknown>) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      style={{ maxWidth: 600, width: '100%' }}
    >
      <Form.Item
        name="nombre"
        label="Name"
        rules={[{ required: true, message: 'Name is required' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="generaCobro" label="Generates Factura" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item>
        <Space wrap size={[8, 8]}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {mode === 'create' ? 'Create Tipo Servicio' : 'Save Changes'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
